import {TemplateApp} from "./app";
import {getCurrentJalaliYear} from './utils.js';

import footerHtml from '../modules/footer.html'
import notFoundHtml from '../modules/404.html'
import serverErrorHtml from '../modules/500.html'

import dashboardHtml from '../views/dashboard.html';
import profileHtml from '../views/profile.html';
import accountingContactsHtml from '../views/accounting-contacts.html';
import accountingSettingsHtml from '../views/accounting-settings.html';

import {initProfilePage} from "./profile";
import {initDashboardPage} from "./dashboard";
import {initAccountingContactsPage, initAccountingSettingsPage} from "./accounting";

const routes = {
    '/dashboard': {
        loader: dashboardHtml,
        init: initDashboardPage
    },
    '/profile': {
        loader: profileHtml,
        init: initProfilePage
    },
    '/accounting-contacts': {
        loader: accountingContactsHtml,
        init: initAccountingContactsPage
    },
    '/accounting-settings': {
        loader: accountingSettingsHtml,
        init: initAccountingSettingsPage
    }
};

function updateFooterYear() {
    const yearElement = document.getElementById('footer-year');
    if (yearElement) {
        yearElement.textContent = getCurrentJalaliYear();
    }
}

function loadRoute(path){
    const normalizedPath = path.length > 1 ? path.replace(/\/$/, '') : path;
    const notFoundRoute = { loader: notFoundHtml, init: null };
    let route = routes[normalizedPath] ? routes[normalizedPath] : notFoundRoute;
    route.path = normalizedPath;
    return route;
}

async function loadPage(path) {
    const pageContentElement = document.getElementById('page-content');
    if (!pageContentElement) return;

    pageContentElement.classList.add('page-is-fading');

    setTimeout(async () => {
        try {
            const route = loadRoute(path);
            const pageModule = route.loader;
            const template = new TemplateApp();
            pageContentElement.innerHTML = pageModule;
            pageContentElement.innerHTML += footerHtml;
            updateFooterYear();
            if (route.init) route.init();
            pageContentElement.classList.remove('page-is-fading');
            template.updateSidebarActiveLink(route.path);
        } catch (error) {
            pageContentElement.innerHTML = serverErrorHtml;
            pageContentElement.innerHTML += footerHtml;
            updateFooterYear();
            pageContentElement.classList.remove('page-is-fading');
            console.error(error);
        }
    }, 200);
}

export function initRouter() {
    document.body.addEventListener('click', e => {
        const link = e.target.closest('a[data-link]');
        if (link) {
            e.preventDefault();
            history.pushState(null, '', link.href);
            loadPage(window.location.pathname).then();
        }
    });

    window.addEventListener('popstate', () => loadPage(window.location.pathname));
    loadPage(window.location.pathname === '/' ? '/dashboard' : window.location.pathname).then();

}
